import {
  GET_ADDEMPLOYEE,
  GET_EMPLOYEEDETAILS,
  GET_EMPLOYEESLIST,
  GET_UPDATEEMPLOYEE,
} from "resources/actionTypes";

const initialEmployeesListState = {
  loading: false,
  error: null,
  employeesList: "",
};

const initialEmployeeDetailsState = {
  loading: false,
  error: null,
  employeeDetails: "",
};

const initialAddEmployeeState = {
  loading: false,
  error: null,
};

const initialUpdateEmployeeState = {
  loading: false,
  error: null,
};

export const getEmployeesList = (state = initialEmployeesListState, action) => {
  switch (action.type) {
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesList: action.employeesList,
      };
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getEmployeeDetails = (
  state = initialEmployeeDetailsState,
  action
) => {
  switch (action.type) {
    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeDetails: action.employeesDetails,
      };
    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_RESET:
      return {
        employeeDetails: "",
      };
    default:
      return state;
  }
};

export const addEmployee = (state = initialAddEmployeeState, action) => {
  switch (action.type) {
    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateEmployee = (state = initialUpdateEmployeeState, action) => {
  switch (action.type) {
    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
